<template>
	<div class="home">
		<HeaderBar :title="title" :leftArrow="true" url="/main/service/service400/patient/followList"></HeaderBar>
		<div class="center-box-no-footer">
			<div class="patient-card-box">
				<div class="patient-card-content">
					<div class="content-title">
						<span class="custom-title">{{form.bq001002}}</span>
						<span class="custom-title">{{form.bq001018}}</span>
					</div>
					<div class="content-info">
						<!-- <div class="patient-status">治疗组</div> -->
						<div class="patient-info-item">{{form.EmployerName}}</div>
						<div class="patient-info-item">{{form.sex}}</div>
						<div class="patient-info-item">{{form.age}}岁</div>
					</div>
					<div class="content-info">
						<div class="patient-info-item">基线：{{config.usertype.find(item=>item.id==form.bq001041).text}}
						</div>
						<div class="patient-info-item" style="margin-bottom: 0.5rem;">
							当前：{{config.usertype.find(item=>item.id==lastFollow.bq400998).text}}</div>
					</div>
					<embed class="patient-icon" :src="patientIcon" type="image/svg+xml"
						pluginspage="http://www.adobe.com/svg/viewer/install/" />
				</div>
			</div>


			<div class="patient-record-box">
				<div class="record-title">随访记录</div>
				<div class="record-item list-cell" v-for="item in recordList" :key="item.guid">
					<van-cell-group>
					<van-cell center>
						<template #title>
							<!-- <div class="record-time">{{item.bq400995.substring(0,10)}}</div> -->
						</template>
						<template #label>
							<div class="record-info-item">
								<div class="record-info-text custom-title">{{item.bs025003}}</div>
								<div class="record-info-type">随访名称</div>
							</div>
							<div class="record-info-item">
								<div class="record-info-text custom-title" v-if="item.bq400996=='0'"
									style="color:#409EFF;">图片采集中</div>
								<div class="record-info-text custom-title" v-if="item.bq400996=='1'"
									style="color:#909399;">图片数据识别中
								</div>
								<div class="record-info-text custom-title" v-if="item.bq400996=='2'"
									style="color:#f56c6c;" @click="showError(item)">数据异常(点击查看)
								</div>
								<div class="record-info-text custom-title" v-if="item.bq400996=='3'"
									style="color:#67c23a;">随访完成</div>
								<!-- <div class="record-info-text custom-title">9个月</div> -->
								<div class="record-info-type">随访数据当前状态</div>
							</div>
							<div class="record-info-item" v-show="false">
								<div class="record-info-text custom-title">-</div>
								<div class="record-info-type">提交转化</div>
							</div>
						</template>
					</van-cell>
					<van-cell v-show='item.extend5!=""'>
						<template #title>
							<div class="custom-title" style="font-size: .8rem;color: red;">缺失数据</div>
						</template>
						<template #label>
							<div class="record-info-item">{{item.extend5}}</div>
						</template>
					</van-cell>
					</van-cell-group>
					<div class="list-cell-footer" v-if="item.bq400996 == '0' ||item.bq400996 == '2'">
						<van-button type="info" style="color: green;" class="footer-button" size="small"
							@click="Record(item)">随访详情
						</van-button>
						<van-button type="warning" style="color: orangered;" class="footer-button" size="small"
							@click="statusSave(item)"  v-show='item.extend5==""'>提交转化
						</van-button>
					</div>
				</div>
			</div>
		</div>


		<div class="patient-bottom-box">
			<div class="patient-button-box">
				<van-button type="info" @click="AddNormalRecord">新增普通随访</van-button>
				<van-button type="primary" @click="AddRandomRecord">新增不定期随访</van-button>
			</div>
		</div>

		<van-dialog v-model="showSubmitDialog" title="提交" show-cancel-button :before-close="beforeSubmit">
			<van-form :model="submitModel">
				<FormNormalInput v-model="submitModel.Bq400record_Remark" label="提交说明"></FormNormalInput>
			</van-form>
		</van-dialog>
		<van-action-sheet v-model="showRecordSet" title="设置">
			<recordSetSelect v-if="showRecordSet" :patientModel="form" :recordSetType="recordSetType"
				:recordSetList="recordSetList" :userType="lastFollow.bq400998" @closeAction="closeSetting">
			</recordSetSelect>
		</van-action-sheet>



		<van-popup v-model="showPopup" closeable position="right" :style="{ width: '100%','height':'100%' }">
			<div class="setting-right-content">
				<followRecordIndex v-if="showPopup"></followRecordIndex>
			</div>
		</van-popup>

			<van-dialog v-model="showErrorDialog" title="异常详情">
				<van-steps direction="vertical" :active="0" active-color="#000">
					<van-step v-for="item in errorList" :key="item.id">
						<h3>{{item.bq4009962}}</h3>
						<p>说明：{{item.Bq400record_Remark==''?'无':item.Bq400record_Remark}}</p>
						<p class="message">{{item.addUserName +' 提交于：'+item.addTime}}</p>
					</van-step>
				</van-steps>
			</van-dialog>
	</div>
</template>

<script>
	import componentsModel from '../base/components.js'
	import followRecordIndex from '../followRecord/index.vue'
	export default {
		name: 's400PatientDetail',
		data() {
			return {
				title: '患者信息',
				searchValue: "",
				// 背景图片
				patientIcon: require("../../../../assets/image/patient-icon.svg"),
				config: JSON.parse(sessionStorage.getItem("config")),
				form: {
					id: "",
				},
				recordList: [],
				loading: false,
				// 新增随访记录pop
				showRecordSet: false,
				// 新增随访类型 1-标准随访，2-不定期随访
				recordSetType: "1",
				// 随访可选数组
				recordSetList: [],
				// 随访记录pop
				showPopup: false,
				// 提交数据
				submitModel: {
					id: "0", //编号
					guid: "", //guid编号
					companyGuid: "", //单位编号
					departmentGuid: "", //部门编号
					checkStatus: "", //审核状态
					dataStatus: "", //数据状态
					addUid: "", //添加人编号
					addTime: "", //添加时间
					bq400recordRemark: "", //修改说明
					bq400996: "", //当前修改状态
					bq4009962: "", //当前状态名称
					bq400guid: "", //随访编号
					addUserName: "", //修改人姓名
					Bq400record_Remark: '', //修改说明
					Bq400_996: '', //当前修改状态
					Bq400_996_2: '', //当前状态名称
					Bq400_guid: '', //随访编号
				},
				// 提交数据窗口变量
				showSubmitDialog: false,
				
				// 异常数据窗口变量
				showErrorDialog: false,
				errorList: [],

				lastFollow: {
					bq400998: 1
				},
			}

		},
		// 页面渲染，初始化form的数据
		created() {
			this.form = this.$route.params
			console.log(this.form);
		},
		components: {
			followRecordIndex,
			...componentsModel
		},
		methods: {
			onSearch() {

			},
			// 记录页面
			Record(item) {
				sessionStorage.setItem('bq400', JSON.stringify(item))
				this.showPopup = true
				// this.$router.push({
				//   name: "s400FollowRecordIndex"
				// })
			},
			// 新增标准随访 , 类型为1
			AddNormalRecord() {
				let that = this
				that.recordSetType = "1"
				that.showRecordSet = true
			},
			// 新增不定期随访, 类型为2
			AddRandomRecord() {
				let that = this
				that.recordSetType = "2"
				that.showRecordSet = true
			},
			// 新增随访完成事件
			closeSetting(model) {
				let that = this
				that.recordList.push(model)
				that.showRecordSet = false
				// 调用查看随访详情接口
				that.Record(model)
			},
			//获取随访列表
			loadinfo: function() {
				let that = this
				var condition = {
					bq001018: this.form.bq001018,
					patuid: this.form.uid,
					currentPage: 1,
					pageSize: 9999,
					recordCount: 0,
					menuid:this.$utils.MenuEnum.followdatalist
				}
				that.$utils.HttpPost(that.$utils.Url.s400 + '/api/S400Bq400/ListByUid', condition, function(d) {
					let dataList = []
					d.data.forEach((item)=>{
						that.$utils.CopyKeyInfo(item, item)
						dataList.push(item)
					})
					// 已选中的随访类型数组
					let typeSelectedList = dataList.map(item => item.bs025003)
					// 获得当前操作所有的类型数组
					let allSetList = that.config.usertype.find(item => item.id == that.form.bq001041).date
					// 获得还未进行的标准随访数据
					that.recordSetList = allSetList.filter(m => typeSelectedList.indexOf(m + "随访") == -1)
					that.recordList = dataList
					that.loading = false
					// that.autoLoadFollow()
				}, null, null, null)
			},

			loadLastFollow: function() {
				let that = this
				var args = {
					bq001018: this.form.bq001018
				}
				that.$utils.HttpPost(this.$utils.Url.s400 + '/api/S400Bq400/LastFollow', args, function(
					d) {
					that.lastFollow = d.data
					that.$utils.CopyKeyInfo(that.lastFollow,that.lastFollow)
				}, null, null, null)
			},
			autoLoadFollow: function() {
				//找到最后一次标准随访，调用方法，显示时间轴
				var followlist = this.recordList.filter(item => {
					return item.bq400999 < 2
				})
				if (followlist) {
					this.clickFollowItem(followlist[followlist.length - 1])
				}
			},
			//保存状态
			statusSave: function(row) {
				let that = this

				// that.submitModel.bq001018 = row.bq001018
				that.submitModel.bq400guid = row.guid
				that.submitModel.bq4009962 = '重新提交转化'
				that.submitModel.bq400996 = 1
				that.submitModel.bq400recordRemark = ""
				that.showSubmitDialog = true
				that.$utils.CopyKeySave(that.submitModel, that.submitModel)
			},
			// 弹窗关闭事件之前，校验是否已经有值
			beforeSbumit: function(action, done) {
				let that = this
				console.log(that.submitModel.bq400recordRemark);
				if (action == "confirm") {
					// if (that.submitModel.Bq400record_Remark) {
						// that.submitModel.Bq400record_Remark = that.submitModel.Bq400record_Remark
						that.$utils.HttpPost(that.$utils.Url.s400 + '/api/S400Bq400record/Save/', that.submitModel,
							function() {
								that.$dialog({
									message: "修改成功"
								})
								that.loadinfo()
								done()
							}, null, null, null)
					// } else {
					// 	that.$toast("请提交说明")
					// 	done(false)
					// }
				} else {
					done()
				}
			},
			// 显示异常详情
			showError: function(row) {
				let that = this
				let condition = {
					bq400guid: row.guid,
					currentPage: 1,
					pageSize: 9999,
					recordCount: 0,
				}
			
				that.$utils.HttpPost(that.$utils.Url.s400 + '/api/S400Bq400record/List', condition, function(d) {
					d.data.forEach((item) => {
						that.$utils.CopyKeyInfo(item, item)
					})
					that.errorList = d.data
					if(that.errorList.length>2){
						that.errorList = that.errorList.slice(-1)
					}
					//整理数据颜色图标
					that.errorList.forEach(item => {
						item.size = 'large'
						item.type = 'primary'
						if (item.bq400996 == "0") { //未提交
							item.color = '#409EFF'
							item.icon = 'el-icon-loading'
						}
						if (item.bq400996 == "1") { //转换中
							item.color = '#909399'
							item.icon = 'el-icon-edit'
						}
						if (item.bq400996 == "2") { //数据异常
							item.color = '#f56c6c'
							item.icon = 'el-icon-warning-outline'
						}
						if (item.bq400996 == "3") { //随访完成
							item.color = '#67c23a'
							item.icon = 'el-icon-check'
						}
			
					})
					that.showErrorDialog = true
				}, null, null, null)
			
			}
		},
		mounted() {
			this.loadinfo()
			this.loadLastFollow()
		}
	}
</script>
<style scoped>
	.center-box-no-footer {
		padding-bottom: 80px;
	}

	.patient-card-box {
		padding: 15px 1rem;
		width: 100%;
		box-sizing: border-box;
	}

	.patient-card-content {
		width: 100%;
		height: 120px;
		background-color: #fff;
		border-radius: 8px;
		padding: 20px;
		box-sizing: border-box;
		position: relative;
	}

	.patient-card-content .content-title span {
		padding-right: 10px;
	}

	.content-info {
		padding-top: 5px;
	}

	.content-info .patient-status {
		margin-right: 10px;
	}

	.patient-status {
		display: inline-block;
		height: 20px;
		width: 60px;
		line-height: 20px;
		text-align: center;
		font-size: 10px !important;
		color: #FF7B61;
		background: rgba(255, 123, 97, 0.06);
		border: 1px solid #FF7B61;
		border-radius: 4px;
		box-sizing: border-box;
	}

	.patient-detail .patient-status.active {
		background: rgba(64, 158, 255, 0.06);
		border: 1px solid #409EFF;
		color: #409EFF;
	}

	.patient-info-item {
		display: inline-block;
		height: 20px;
		line-height: 20px;
		padding: 0 10px;
		background: #F7F7F7;
		border-radius: 4px;
		font-size: 10px;
		color: #666666;
		text-align: center;
		margin-right: 10px;
	}

	.patient-icon {
		position: absolute;
		right: 0;
		bottom: 0;
		width: 83px;
		height: 87px;
	}

	.patient-record-box {
		padding-top: 5px;
		padding: 5px 1rem 0 1rem;
	}

	.patient-record-box .record-title {
		font-size: 14px;
		color: #666666;
		line-height: 14px;
		font-weight: 400;
		padding-bottom: 10px;
	}

	.record-item {
		/* padding-bottom: 10px; */

	}

	.record-item .van-cell--center {
		border-radius: 9px;
		padding: 20px;
	}

	.record-item .record-time {
		font-size: 14px;
		color: #666666;
		line-height: 14px;
		font-weight: 400;
	}

	.record-item .van-cell__label {
		display: flex;
	}

	.record-info-item {
		flex: 1;
		display: inline-block;
		padding-top: 15px;
	}

	.record-info-type {
		font-size: 14px;
		color: #999999;
		line-height: 14px;
		font-weight: 400;
		padding-top: 10px;
	}

	.patient-bottom-box {
		width: 100%;
		height: 80px;
		padding: 0 1rem;
		box-sizing: border-box;
		position: fixed;
		bottom: 0;
	}

	.patient-bottom-box .patient-button-box {
		background-color: #fff;
		width: 100%;
		height: 100%;
		padding-bottom: 10px;
		box-sizing: border-box;
		display: flex;
		justify-content: space-between;
		align-items: flex-end;
	}

	.patient-bottom-box .patient-button-box .van-button {
		width: 48%;
	}

	.list-cell .list-cell-footer {
		border-top: none
	}
</style>
